$(document).ready(function() {
   
   $('#cart_over').hide();
  // EVERYTHING FOR THE CART
   var overlay = $("#cart_slide");
   var cartContainer = $("#cart_over");

  function cartOpen() {
    cartContainer.fadeIn('fast');
  }

  function cartClose() {
    cartContainer.fadeOut('medium');
  }


  $( "#cart_tab" ).hover(
    function() {
       cartOpen();
    }, function() {
       cartClose();
    }
    ); 


  $("#add").click(function () {
      cartOpen();
    });

  $("#add-to-cart-msg").click(function () {
      cartOpen();
    });

 $("#cart_close").click(function () {
      cartClose();
    });


});